
export default {
  name: 'ModalView',
  components: {
    CreateLogisticPenalty: () => import('@/views/pages/penaltyCreate/createLogisticPenalty/CreateLogisticPenalty.vue')
  },
  props: {
    comp: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      value: null
    }
  },
  computed: {
    modalInfo (): any {
      return this.$store.getters['ui/modalInfo']
    },
    param (): any {
      return this.comp.param
    },
    secondParam (): any {
      return this.comp.secondParam
    }
  },
  mounted () {
    this.value = this.comp.component
  }
}
